import { createReducer, on } from '@ngrx/store';
import * as actions from '../actions';
import { ILegalEntitiesBusinessesResponse } from '../models/shared.model';

export const legalEntitiesKey = 'legalEntities';

export interface LegalEntitiesState {
  legalEntitiesSuccess: ILegalEntitiesBusinessesResponse[];
  legalEntitiesFailure: any;
  loaded: boolean;
}

export const initialLegalEntitiesState: LegalEntitiesState = {
  legalEntitiesSuccess: undefined,
  legalEntitiesFailure: undefined,
  loaded: false
};

export const legalEntitiesReducer = createReducer(
  initialLegalEntitiesState,
  on(actions.loadLegalEntities, (state, action) => ({
    ...state,
    loaded: false
  })),
  on(actions.loadLegalEntitiesSuccess, (state, action) => ({
    ...state,
    legalEntitiesSuccess: action.response,
    loaded: true
  })),
  on(actions.loadLegalEntitiesFailure, (state, action) => ({
    ...state,
    legalEntitiesFailure: action.error,
    loaded: false
  }))
);

export const legalEntitiesLoaded = (state: LegalEntitiesState) => state.loaded;
export const getLegalEntitiesResponse = (state: { legalEntitiesSuccess: any; }) => state.legalEntitiesSuccess;
